import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'appPackage',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  emptyMessage: "You don't have providers, go to virtual ticket section to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the virtual ticket provider.',
    },
  ],
};
